import React, { useContext, useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import Cookies from "universal-cookie";
import { submit_rate } from "../Drivers/ratings";
import { get_id } from "../Libs/Identification";
import Context from "../Context";

const uni_cookies = new Cookies();
const user_id = get_id(uni_cookies);

const Star = ({ filled, entered }) => {
  const className = filled ? "fa fa-star" : "fa fa-star-o";
  return (
    <div
      style={{
        display: "inline-block",
        width: 40,
        height: 40,
        fontSize: 25,
        color: "cornflowerblue",
      }}
      onMouseEnter={entered}
    >
      <i className={className} aria-hidden="true"></i>
    </div>
  );
};
export default () => {
  const context = useContext(Context);
  const [show, set_show] = useState(false);
  const [value, set_value] = useState(60);
  const [description, set_description] = useState("");

  const openRating = () => {
    if (!context.cookie.get("ghorfeyar_rated", false)) {
      set_show(true);
    }
  };
  const setRatingTimeout = () => {
    setTimeout(openRating, 1000 * 60 * 12);
  };
  const render_stars = () => {
    let values = [
      value >= 20,
      value >= 40,
      value >= 60,
      value >= 80,
      value === 100,
    ];
    let result = [];
    for (let i = 0; i < values.length; i++) {
      result.push(
        <Star
          key={i}
          index={i}
          filled={value / 20 <= i + 1}
          entered={() => {
            set_value((i + 1) * 20);
          }}
        />
      );
    }
    return result;
  };

  const accept = () => {
    const data = {
      value: value,
      context: "cite",
    };
    if (description !== "") data["description"] = description;
    submit_rate(
      user_id,
      data,
      () => {
        uni_cookies.set("ghorfeyar_rated", true);
        set_show(false);
      },
      () => {}
    );
  };
  const never = () => {
    uni_cookies.set("ghorfeyar_rated", true);
    set_show(false);
  };
  const later = () => {
    setRatingTimeout();
    set_show(false);
  };
  useEffect(setRatingTimeout, []);
  return (
    <Modal
      show={show}
      style={{ zIndex: 9999 }}
      onHide={() => {
        set_show(false);
      }}>
      <Modal.Header closeButton>
        <Modal.Title>چطور بود؟</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12}>
            لطفا نظر خود را در استفاده از استناد دهی آنلاین به ما بگویید
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ textAlign: "center" }}>
            {render_stars()}
          </Col>
          <Col md={12}>
            <Form.Group>
              <Form.Control
                type="text"
                className="text-right cite__inp"
                defaultValue={description}
                placeholder="به نظر من که عالی هست."
                onChange={e => {
                  set_description(e.target.value);
                }}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={later}>
          هنوز کار نکردم.
        </Button>
        <Button variant="default" onClick={never}>
          من نظری ندارم.
        </Button>
        <Button variant="primary" onClick={accept}>
          باشه!
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
